<ng-container *ngIf="banner$ | async as data">
  <sd-banner-content [responsiveBannerData]="data"></sd-banner-content>
</ng-container>
